import React, { createContext, useReducer } from 'react';

const Store = createContext();

const initialState = {
  didResetPassword: false,
  isStateApplied: false,
};

const reducer = (state, action) => {
  const actions = {
    HYDRATE_WITH_SERVER_DATA: () => ({
      ...state,
      isStateApplied: true,
      ...action.payload,
      // Request time should only be available once after actual server request
      requestTime: null,
    }),
    RESET_PASSWORD: () => ({
      ...state,
      didResetPassword: true,
      knownUser: null,
      username: null,
    }),
    SET_USERNAME: () => ({
      ...state,
      username: action.payload.username,
    }),
    default: () => state,
  };

  return (actions[action.type] || actions.default)();
};

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Store.Provider value={{ state, dispatch }}>{children}</Store.Provider>
  );
};

export const storeToStateWhenReady = (state, storeState) =>
  Object.keys(storeState)
    .filter(key => key !== 'isStateApplied')
    .map(key => ({
      [key]: storeState.isStateApplied ? storeState[key] : state[key],
    }))
    .reduce((acc, keyValue) => ({ ...acc, ...keyValue }), state);

export default Store;
